module.exports = __webpack_public_path__ + "static/media/dureza.5d0b17f6.jpg";